import { z } from "zod"

import { InventoryHoldArea } from "./constants"

import { WarehouseShelvingBinSize } from "@/graphql/codegen/graphql"

export const inventoryShelvingFormSchema = z.object({
  binSize: z.nativeEnum(WarehouseShelvingBinSize).nullable(),
  aisleCode: z.string().nullable(),
  sectionCode: z.string().nullable(),
  binNumber: z.number().nullable(),
  warehouseShelvingId: z.string().nullable(),
})

export type InventoryShelvingFormValues = z.infer<typeof inventoryShelvingFormSchema>

export const validateRequiredShelving = (ctx: z.RefinementCtx, shelving: InventoryShelvingFormValues): void => {
  if (!shelving.aisleCode) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["shelving", "aisleCode"], message: "Aisle is required" })
  }

  if (!shelving.sectionCode) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["shelving", "sectionCode"], message: "Shelf is required" })
  }

  if (!shelving.binNumber) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["shelving", "binNumber"], message: "Bin is required" })
  }

  if (!shelving.warehouseShelvingId) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["shelving", "warehouseShelvingId"], message: "Bin is required" })
  }
}

export const inventoryDestinationFormSchema = z
  .object({
    holdArea: z.nativeEnum(InventoryHoldArea, { required_error: "Area is required" }),
    shelving: inventoryShelvingFormSchema,
  })
  .superRefine((data, ctx) => {
    if (data.holdArea !== InventoryHoldArea.Warehouse) return

    validateRequiredShelving(ctx, data.shelving)
  })

export type InventoryDestinationFormValues = z.infer<typeof inventoryDestinationFormSchema>
